

(function () {
  const config = window.CUSTOM_PRICING || {};
  const isLoggedIn = config.isLoggedIn || false;
  const promotions = config.promotions || [];

/*   function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' zł';
  }

  function getActivePromo() { */
    // Preserves whatever currency format Shopify already rendered server-side
  // (correct symbol/position for the visitor's active currency, e.g. zł for
  // Poland, € for other markets) instead of hardcoding a single currency.
  function getMoneyTemplate(container, labelEl) {
    if (!container.dataset.moneyTemplate && labelEl && labelEl.textContent.trim()) {
      container.dataset.moneyTemplate = labelEl.textContent.replace(/[\d\s.,]+/, '{{AMOUNT}}');
    }
    return container.dataset.moneyTemplate;
  }

  function formatMoney(cents, template) {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    if (template && template.indexOf('{{AMOUNT}}') !== -1) {
      return template.replace('{{AMOUNT}}', amount);
    }
    return amount + ' zł';
  }

  function getActivePromo() {
    const now = new Date();
    for (const promo of promotions) {
      if (promo.handle === 'member-base') continue;
      if (!promo.active) continue;
      const startsAt = promo.starts_at ? new Date(promo.starts_at) : null;
      const endsAt = promo.ends_at ? new Date(promo.ends_at) : null;
      const started = !startsAt || now >= startsAt;
      const notEnded = !endsAt || now <= endsAt;
      if (started && notEnded) return promo;
    }
    return null;
  }

  function updatePriceContainer(container) {
    const basePrice = parseInt(container.dataset.basePrice, 10);
    const priceMin = parseInt(container.dataset.priceMin, 10);
    const priceMax = parseInt(container.dataset.priceMax, 10);
    const hasVolumePricing = container.dataset.hasVolumePricing === 'true';
    const discountPercent = parseInt(container.dataset.discountPercent, 10) || 0;

    if (!basePrice) return;

    const memberBase = promotions.find(p => p.handle === 'member-base');
    const memberBaseDiscount = memberBase ? memberBase.member_discount_percent : 10;
    const activePromo = getActivePromo();
    const promo = (activePromo && discountPercent > 0) ? activePromo : null;

    let displayPrice, comparePrice;

    if (isLoggedIn) {
      if (promo && promo.member_discount_percent > 0) {
        comparePrice = basePrice;
        displayPrice = Math.round(basePrice * (1 - promo.member_discount_percent / 100));
      } else {
        comparePrice = basePrice;
        displayPrice = Math.round(basePrice * (1 - memberBaseDiscount / 100));
      }
    } else {
      if (promo && promo.discount_percent > 0) {
        comparePrice = basePrice;
        displayPrice = Math.round(basePrice * (1 - promo.discount_percent / 100));
      } else {
        comparePrice = 0;
        displayPrice = basePrice;
      }
    }

    /* const priceLabel = container.querySelector('[data-price-label]');
    const compareLabel = container.querySelector('[data-compare-label]');
    let compareGroup = container.querySelector('.price-compare-group');

    if (hasVolumePricing && priceMin && priceMax) {
      const discPct = promo
        ? (isLoggedIn ? promo.member_discount_percent : promo.discount_percent)
        : (isLoggedIn ? memberBaseDiscount : 0);
      const minDisplay = Math.round(priceMin * (1 - discPct / 100));
      const maxDisplay = Math.round(priceMax * (1 - discPct / 100));
      if (priceLabel) {
        priceLabel.textContent = formatMoney(minDisplay) + ' - ' + formatMoney(maxDisplay);
      }
    } else {
      if (priceLabel) priceLabel.textContent = formatMoney(displayPrice);
    }

    if (comparePrice > 0 && comparePrice > displayPrice) {
      if (compareGroup) {
        // Элемент уже есть — обновляем и показываем
        const lbl = compareGroup.querySelector('[data-compare-label]');
        if (lbl) lbl.textContent = formatMoney(comparePrice);
        compareGroup.style.display = '';
      } else {
        // Элемента нет — создаём динамически
        compareGroup = document.createElement('span');
        compareGroup.setAttribute('role', 'group');
        compareGroup.className = 'price-compare-group';
        compareGroup.innerHTML =
          '<span class="visually-hidden">Cena regularna&nbsp;</span>' +
          '<span class="compare-at-price" data-compare-label>' + formatMoney(comparePrice) + '</span>';
        container.appendChild(compareGroup);

      }
    } else {
      if (compareGroup) compareGroup.style.display = 'none';
    } */

          const priceLabel = container.querySelector('[data-price-label]');
    const compareLabel = container.querySelector('[data-compare-label]');
    let compareGroup = container.querySelector('.price-compare-group');
    const tpl = getMoneyTemplate(container, priceLabel || compareLabel);

    if (hasVolumePricing && priceMin && priceMax) {
      const discPct = promo
        ? (isLoggedIn ? promo.member_discount_percent : promo.discount_percent)
        : (isLoggedIn ? memberBaseDiscount : 0);
      const minDisplay = Math.round(priceMin * (1 - discPct / 100));
      const maxDisplay = Math.round(priceMax * (1 - discPct / 100));
      if (priceLabel) {
        priceLabel.textContent = formatMoney(minDisplay, tpl) + ' - ' + formatMoney(maxDisplay, tpl);
      }
    } else {
      if (priceLabel) priceLabel.textContent = formatMoney(displayPrice, tpl);
    }

    if (comparePrice > 0 && comparePrice > displayPrice) {
      if (compareGroup) {
        // Элемент уже есть — обновляем и показываем
        const lbl = compareGroup.querySelector('[data-compare-label]');
        if (lbl) lbl.textContent = formatMoney(comparePrice, tpl);
        compareGroup.style.display = '';
      } else {
        // Элемента нет — создаём динамически
        compareGroup = document.createElement('span');
        compareGroup.setAttribute('role', 'group');
        compareGroup.className = 'price-compare-group';
        compareGroup.innerHTML =
          '<span class="visually-hidden">Cena regularna&nbsp;</span>' +
          '<span class="compare-at-price" data-compare-label>' + formatMoney(comparePrice, tpl) + '</span>';
        container.appendChild(compareGroup);

      }
    } else {
      if (compareGroup) compareGroup.style.display = 'none';
    }


// Omnibus text
const omnibusEl = container.nextElementSibling;
if (omnibusEl && omnibusEl.classList.contains('omnibus-price')) {
  if (comparePrice > 0 && comparePrice > displayPrice) {
    omnibusEl.style.display = '';
  } else {
    omnibusEl.style.display = 'none';
  }
}


  }

  function updateCartPrices() {
    document.querySelectorAll('.cart-price-item[data-base-price]').forEach(function (container) {
      const basePrice = parseInt(container.dataset.basePrice, 10);
      const quantity = parseInt(container.dataset.lineQuantity, 10) || 1;
      const discountPercent = parseInt(container.dataset.discountPercent, 10) || 0;
      if (!basePrice) return;

      const memberBase = promotions.find(p => p.handle === 'member-base');
      const memberBaseDiscount = memberBase ? memberBase.member_discount_percent : 10;
      const activePromo = getActivePromo();
      const promo = (activePromo && discountPercent > 0) ? activePromo : null;

      let displayPrice, comparePrice;

      if (isLoggedIn) {
        if (promo && promo.member_discount_percent > 0) {
          comparePrice = basePrice;
          displayPrice = Math.round(basePrice * (1 - promo.member_discount_percent / 100));
        } else {
          comparePrice = basePrice;
          displayPrice = Math.round(basePrice * (1 - memberBaseDiscount / 100));
        }
      } else {
        if (promo && promo.discount_percent > 0) {
          comparePrice = basePrice;
          displayPrice = Math.round(basePrice * (1 - promo.discount_percent / 100));
        } else {
          comparePrice = 0;
          displayPrice = basePrice;
        }
      }

      const lineTotal = displayPrice * quantity;
      const compareTotal = comparePrice * quantity;

      /* const priceLabel = container.querySelector('[data-price-label]');
      const compareLabel = container.querySelector('[data-compare-label]');
      const compareGroup = container.querySelector('.price-compare-group');

      if (priceLabel) priceLabel.textContent = formatMoney(lineTotal);

      if (comparePrice > 0 && comparePrice > displayPrice) {
        if (compareLabel) compareLabel.textContent = formatMoney(compareTotal);
        if (compareGroup) compareGroup.style.display = '';
      } else {
        if (compareGroup) compareGroup.style.display = 'none';
      }
    });
  } */
      const priceLabel = container.querySelector('[data-price-label]');
      const compareLabel = container.querySelector('[data-compare-label]');
      const compareGroup = container.querySelector('.price-compare-group');
      const tpl = getMoneyTemplate(container, priceLabel || compareLabel);

      if (priceLabel) priceLabel.textContent = formatMoney(lineTotal, tpl);

      if (comparePrice > 0 && comparePrice > displayPrice) {
        if (compareLabel) compareLabel.textContent = formatMoney(compareTotal, tpl);
        if (compareGroup) compareGroup.style.display = '';
      } else {
        if (compareGroup) compareGroup.style.display = 'none';
      }
    });
  }



function updateBadges() {
  const promo = getActivePromo();
  const memberBase = promotions.find(p => p.handle === 'member-base');

  document.querySelectorAll('.card-badge-promo').forEach(function (badge) {
    // Находим ближайший price-container для этого товара
    const card = badge.closest('product-card, .product-card, [data-product-id]');
    const priceContainer = card
      ? card.querySelector('.price-container[data-base-price]')
      : null;
    const discountPercent = priceContainer
      ? parseInt(priceContainer.dataset.discountPercent, 10) || 0
      : 0;

    // Показываем бейдж только если есть акция И товар акционный (discount_percent > 0)
    if (promo && promo.title && discountPercent > 0) {
      badge.textContent = promo.title;
      badge.style.display = '';
    } else {
      badge.style.display = 'none';
    }
  });

  document.querySelectorAll('.card-badge-member').forEach(function (badge) {
    if (isLoggedIn && memberBase && memberBase.title) {
      badge.textContent = memberBase.title;
      badge.style.display = '';
    } else {
      badge.style.display = 'none';
    }
  });
}


  function updateAllPrices() {
    document.querySelectorAll('.price-container[data-base-price]').forEach(updatePriceContainer);
    updateCartPrices();
    updateBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllPrices);
  } else {
    updateAllPrices();
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('price-container')) {
            updatePriceContainer(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('.price-container[data-base-price]').forEach(updatePriceContainer);
            if (node.querySelectorAll('.cart-price-item[data-base-price]').length > 0) {
              updateCartPrices();
            }
            if (node.querySelectorAll('.card-badge-promo').length > 0) {
              updateBadges();
            }
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('input', function (e) {
    if (e.target.matches('input[type="search"], input[name="q"]')) {
      setTimeout(updateAllPrices, 500);
      setTimeout(updateAllPrices, 1000);
      setTimeout(updateAllPrices, 2000);
    }
  });

  document.addEventListener('focusin', function (e) {
    if (e.target.matches('input[type="search"], input[name="q"]')) {
      setTimeout(updateAllPrices, 300);
    }
  });

  document.addEventListener('click', function () {
    setTimeout(updateAllPrices, 300);
    setTimeout(updateAllPrices, 800);
  });

  document.addEventListener('cart:open', function () {
    setTimeout(updateAllPrices, 300);
  });

  document.addEventListener('drawer:open', function () {
    setTimeout(updateAllPrices, 300);
  });

})();





/* 
(function () {
  const config = window.CUSTOM_PRICING || {};
  const isLoggedIn = config.isLoggedIn || false;
  const promotions = config.promotions || [];

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' zł';
  }

  function getActivePromo(productCollections) {
    const now = new Date();
    for (const promo of promotions) {
      if (promo.handle === 'member-base') continue;
      if (!promo.active) continue;
      const startsAt = promo.starts_at ? new Date(promo.starts_at) : null;
      const endsAt = promo.ends_at ? new Date(promo.ends_at) : null;
      const started = !startsAt || now >= startsAt;
      const notEnded = !endsAt || now <= endsAt;
      if (!started || !notEnded) continue;

      // Если у акции указана коллекция — проверяем принадлежность товара
      if (promo.collection_handle && promo.collection_handle !== 'null') {
        if (!productCollections || !productCollections.includes(promo.collection_handle)) continue;
      }

      return promo;
    }
    return null;
  }

  function updatePriceContainer(container) {
    const basePrice = parseInt(container.dataset.basePrice, 10);
    const priceMin = parseInt(container.dataset.priceMin, 10);
    const priceMax = parseInt(container.dataset.priceMax, 10);
    const hasVolumePricing = container.dataset.hasVolumePricing === 'true';
const productCollections = window.CURRENT_PRODUCT_COLLECTIONS || 
  (container.dataset.collections ? container.dataset.collections.split(',') : null);


    if (!basePrice) return;

    const promo = getActivePromo(productCollections);
    const memberBase = promotions.find(p => p.handle === 'member-base');
    const memberBaseDiscount = memberBase ? memberBase.member_discount_percent : 10;

    let displayPrice, comparePrice;

    if (isLoggedIn) {
      if (promo && promo.member_discount_percent > 0) {
        comparePrice = basePrice;
        displayPrice = Math.round(basePrice * (1 - promo.member_discount_percent / 100));
      } else {
        comparePrice = basePrice;
        displayPrice = Math.round(basePrice * (1 - memberBaseDiscount / 100));
      }
    } else {
      if (promo && promo.discount_percent > 0) {
        comparePrice = basePrice;
        displayPrice = Math.round(basePrice * (1 - promo.discount_percent / 100));
      } else {
        comparePrice = 0;
        displayPrice = basePrice;
      }
    }

    const priceLabel = container.querySelector('[data-price-label]');
    const compareLabel = container.querySelector('[data-compare-label]');
    const compareGroup = container.querySelector('.price-compare-group');

    if (hasVolumePricing && priceMin && priceMax) {
      const discPct = promo
        ? (isLoggedIn ? promo.member_discount_percent : promo.discount_percent)
        : (isLoggedIn ? memberBaseDiscount : 0);
      const minDisplay = Math.round(priceMin * (1 - discPct / 100));
      const maxDisplay = Math.round(priceMax * (1 - discPct / 100));
      if (priceLabel) {
        priceLabel.textContent = formatMoney(minDisplay) + ' - ' + formatMoney(maxDisplay);
      }
    } else {
      if (priceLabel) priceLabel.textContent = formatMoney(displayPrice);
    }

    if (comparePrice > 0 && comparePrice > displayPrice) {
      if (compareLabel) compareLabel.textContent = formatMoney(comparePrice);
      if (compareGroup) {
        compareGroup.style.display = '';
      } else if (compareLabel) {
        const group = compareLabel.closest('[role="group"]');
        if (group)
 */











/* 

(function () {
  const config = window.CUSTOM_PRICING || {};
  const isLoggedIn = config.isLoggedIn || false;
  const promotions = config.promotions || [];

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' zł';
  }

  function getActivePromo() {
    const now = new Date();
    for (const promo of promotions) {
      if (promo.handle === 'member-base') continue;
      if (!promo.active) continue;
      const startsAt = promo.starts_at ? new Date(promo.starts_at) : null;
      const endsAt = promo.ends_at ? new Date(promo.ends_at) : null;
      const started = !startsAt || now >= startsAt;
      const notEnded = !endsAt || now <= endsAt;
      if (started && notEnded) return promo;
    }
    return null;
  }

  function calculatePrices(basePrice, metafieldDiscount) {
    const promo = getActivePromo();
    const memberBase = promotions.find(p => p.handle === 'member-base');
    const memberBaseDiscount = memberBase ? memberBase.member_discount_percent : 10;

    let displayPrice, comparePrice;

    if (isLoggedIn) {
      if (promo && promo.member_discount_percent > 0) {
        comparePrice = basePrice;
        displayPrice = Math.round(basePrice * (1 - promo.member_discount_percent / 100));
      } else {
        comparePrice = basePrice;
        displayPrice = Math.round(basePrice * (1 - memberBaseDiscount / 100));
      }
    } else {
      if (promo && promo.discount_percent > 0) {
        // JS акция активна — используем её
        comparePrice = basePrice;
        displayPrice = Math.round(basePrice * (1 - promo.discount_percent / 100));
      } else if (metafieldDiscount > 0) {
        // Нет JS акции, но есть метафилд на товаре
        comparePrice = basePrice;
        displayPrice = Math.round(basePrice * (1 - metafieldDiscount / 100));
      } else {
        // Нет никакой скидки
        comparePrice = 0;
        displayPrice = basePrice;
      }
    }

    return { displayPrice, comparePrice };
  }

  function updatePriceContainer(container) {
    const basePrice = parseInt(container.dataset.basePrice, 10);
    const metafieldDiscount = parseInt(container.dataset.compareAtPrice, 10) > 0
      ? 0
      : (parseInt(container.dataset.compareAtPrice, 10) || 0);
    const priceMin = parseInt(container.dataset.priceMin, 10);
    const priceMax = parseInt(container.dataset.priceMax, 10);
    const hasVolumePricing = container.dataset.hasVolumePricing === 'true';

    if (!basePrice) return;

    // Читаем процент скидки из data-атрибута (мы передадим его отдельно)
    const discountPercent = parseInt(container.dataset.discountPercent, 10) || 0;

    const { displayPrice, comparePrice } = calculatePrices(basePrice, discountPercent);

    const priceLabel = container.querySelector('[data-price-label]');
    const compareLabel = container.querySelector('[data-compare-label]');
    const compareGroup = container.querySelector('.price-compare-group');

    if (hasVolumePricing && priceMin && priceMax) {
      const { displayPrice: minDisplay } = calculatePrices(priceMin, discountPercent);
      const { displayPrice: maxDisplay } = calculatePrices(priceMax, discountPercent);
      if (priceLabel) {
        priceLabel.textContent = formatMoney(minDisplay) + ' - ' + formatMoney(maxDisplay);
      }
    } else {
      if (priceLabel) {
        priceLabel.textContent = formatMoney(displayPrice);
      }
    }

    if (comparePrice > 0 && comparePrice > displayPrice) {
      if (compareLabel) compareLabel.textContent = formatMoney(comparePrice);
      if (compareGroup) {
        compareGroup.style.display = '';
      } else if (compareLabel) {
        const group = compareLabel.closest('[role="group"]');
        if (group) group.style.display = '';
      }
    } else {
      if (compareGroup) {
        compareGroup.style.display = 'none';
      } else if (compareLabel) {
        const group = compareLabel.closest('[role="group"]');
        if (group) group.style.display = 'none';
      }
    }
  }

  function updateCartPrices() {
    document.querySelectorAll('.cart-price-item[data-base-price]').forEach(function (container) {
      const basePrice = parseInt(container.dataset.basePrice, 10);
      const quantity = parseInt(container.dataset.lineQuantity, 10) || 1;
      if (!basePrice) return;

      const discountPercent = parseInt(container.dataset.discountPercent, 10) || 0;
      const { displayPrice, comparePrice } = calculatePrices(basePrice, discountPercent);
      const lineTotal = displayPrice * quantity;
      const compareTotal = comparePrice * quantity;

      const priceLabel = container.querySelector('[data-price-label]');
      const compareLabel = container.querySelector('[data-compare-label]');
      const compareGroup = container.querySelector('.price-compare-group');

      if (priceLabel) {
        priceLabel.textContent = formatMoney(lineTotal);
      }

      if (comparePrice > 0 && comparePrice > displayPrice) {
        if (compareLabel) compareLabel.textContent = formatMoney(compareTotal);
        if (compareGroup) compareGroup.style.display = '';
      } else {
        if (compareGroup) compareGroup.style.display = 'none';
      }
    });
  }

  function updateBadges() {
    const promo = getActivePromo();
    const memberBase = promotions.find(p => p.handle === 'member-base');

    document.querySelectorAll('.card-badge-promo').forEach(function (badge) {
      if (promo && promo.title) {
        badge.textContent = promo.title;
        badge.style.display = '';
      } else {
        badge.style.display = 'none';
      }
    });

    document.querySelectorAll('.card-badge-member').forEach(function (badge) {
      if (isLoggedIn && memberBase && memberBase.title) {
        badge.textContent = memberBase.title;
        badge.style.display = '';
      } else {
        badge.style.display = 'none';
      }
    });
  }

  function updateAllPrices() {
    document.querySelectorAll('.price-container[data-base-price]').forEach(updatePriceContainer);
    updateCartPrices();
    updateBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllPrices);
  } else {
    updateAllPrices();
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('price-container')) {
            updatePriceContainer(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('.price-container[data-base-price]').forEach(updatePriceContainer);
            if (node.querySelectorAll('.cart-price-item[data-base-price]').length > 0) {
              updateCartPrices();
            }
            if (node.querySelectorAll('.card-badge-promo').length > 0) {
              updateBadges();
            }
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true,

 */








/* 


(function () {
  const config = window.CUSTOM_PRICING || {};
  const isLoggedIn = config.isLoggedIn || false;
  const promotions = config.promotions || [];

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' zł';
  }

  function getActivePromo() {
    const now = new Date();
    for (const promo of promotions) {
      if (promo.handle === 'member-base') continue;
      if (!promo.active) continue;
      const startsAt = promo.starts_at ? new Date(promo.starts_at) : null;
      const endsAt = promo.ends_at ? new Date(promo.ends_at) : null;
      const started = !startsAt || now >= startsAt;
      const notEnded = !endsAt || now <= endsAt;
      if (started && notEnded) return promo;
    }
    return null;
  }

  function calculatePrices(basePrice) {
    const promo = getActivePromo();
    const memberBase = promotions.find(p => p.handle === 'member-base');
    const memberBaseDiscount = memberBase ? memberBase.member_discount_percent : 10;

    let displayPrice, comparePrice;

    if (isLoggedIn) {
      if (promo && promo.member_discount_percent > 0) {
        comparePrice = basePrice;
        displayPrice = Math.round(basePrice * (1 - promo.member_discount_percent / 100));
      } else {
        comparePrice = basePrice;
        displayPrice = Math.round(basePrice * (1 - memberBaseDiscount / 100));
      }
    } else {
      if (promo && promo.discount_percent > 0) {
        comparePrice = basePrice;
        displayPrice = Math.round(basePrice * (1 - promo.discount_percent / 100));
      } else {
        comparePrice = 0;
        displayPrice = basePrice;
      }
    }

    return { displayPrice, comparePrice };
  }

  function updatePriceContainer(container) {
    const basePrice = parseInt(container.dataset.basePrice, 10);
    const liquidComparePrice = parseInt(container.dataset.compareAtPrice, 10) || 0;
    const priceMin = parseInt(container.dataset.priceMin, 10);
    const priceMax = parseInt(container.dataset.priceMax, 10);
    const hasVolumePricing = container.dataset.hasVolumePricing === 'true';

    if (!basePrice) return;

    const { displayPrice, comparePrice } = calculatePrices(basePrice);

    // Если JS акция не даёт comparePrice — используем значение из Liquid (метафилд discount_percent)
    const finalComparePrice = comparePrice > 0 ? comparePrice : liquidComparePrice;
    const finalDisplayPrice = comparePrice > 0 ? displayPrice : basePrice;

    const priceLabel = container.querySelector('[data-price-label]');
    const compareLabel = container.querySelector('[data-compare-label]');
    const compareGroup = container.querySelector('.price-compare-group');

    if (hasVolumePricing && priceMin && priceMax) {
      const { displayPrice: minDisplay } = calculatePrices(priceMin);
      const { displayPrice: maxDisplay } = calculatePrices(priceMax);
      if (priceLabel) {
        priceLabel.textContent = formatMoney(minDisplay) + ' - ' + formatMoney(maxDisplay);
      }
    } else {
      if (priceLabel) {
        priceLabel.textContent = formatMoney(finalDisplayPrice);
      }
    }

    if (finalComparePrice > 0 && finalComparePrice > finalDisplayPrice) {
      if (compareLabel) compareLabel.textContent = formatMoney(finalComparePrice);
      if (compareGroup) {
        compareGroup.style.display = '';
      } else if (compareLabel) {
        const group = compareLabel.closest('[role="group"]');
        if (group) group.style.display = '';
      }
    } else {
      if (compareGroup) {
        compareGroup.style.display = 'none';
      } else if (compareLabel) {
        const group = compareLabel.closest('[role="group"]');
        if (group) group.style.display = 'none';
      }
    }
  }

  function updateCartPrices() {
    document.querySelectorAll('.cart-price-item[data-base-price]').forEach(function (container) {
      const basePrice = parseInt(container.dataset.basePrice, 10);
      const quantity = parseInt(container.dataset.lineQuantity, 10) || 1;
      if (!basePrice) return;

      const { displayPrice, comparePrice } = calculatePrices(basePrice);
      const lineTotal = displayPrice * quantity;
      const compareTotal = comparePrice * quantity;

      const priceLabel = container.querySelector('[data-price-label]');
      const compareLabel = container.querySelector('[data-compare-label]');
      const compareGroup = container.querySelector('.price-compare-group');

      if (priceLabel) {
        priceLabel.textContent = formatMoney(lineTotal);
      }

      if (comparePrice > 0 && comparePrice > displayPrice) {
        if (compareLabel) compareLabel.textContent = formatMoney(compareTotal);
        if (compareGroup) compareGroup.style.display = '';
      } else {
        if (compareGroup) compareGroup.style.display = 'none';
      }
    });
  }

  function updateBadges() {
    const promo = getActivePromo();
    const memberBase = promotions.find(p => p.handle === 'member-base');

    document.querySelectorAll('.card-badge-promo').forEach(function (badge) {
      if (promo && promo.title) {
        badge.textContent = promo.title;
        badge.style.display = '';
      } else {
        badge.style.display = 'none';
      }
    });

    document.querySelectorAll('.card-badge-member').forEach(function (badge) {
      if (isLoggedIn && memberBase && memberBase.title) {
        badge.textContent = memberBase.title;
        badge.style.display = '';
      } else {
        badge.style.display = 'none';
      }
    });
  }

  function updateAllPrices() {
    document.querySelectorAll('.price-container[data-base-price]').forEach(updatePriceContainer);
    updateCartPrices();
    updateBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllPrices);
  } else {
    updateAllPrices();
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('price-container')) {
            updatePriceContainer(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('.price-container[data-base-price]').forEach(updatePriceContainer);
            if (node.querySelectorAll('.cart-price-item[data-base-price]').length > 0) {
              updateCartPrices();
            }
            if (node.querySelectorAll('.card-badge-promo').length > 0) {
              updateBadges();
            }
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('input', function (e) {
    if (e.target.matches('input[type="search"], input[name="q"]')) {
      setTimeout(updateAllPrices, 500);
      setTimeout(updateAllPrices, 1000);
      setTimeout(updateAllPrices, 2000);
    }
  });

  document.addEventListener('focusin', function (e) {
    if (e.target.matches('input[type="search"], input[name="q"]')) {
      setTimeout(updateAllPrices, 300);
    }
  });

  document.addEventListener('click', function (e) {
    setTimeout(updateAllPrices, 300);
    setTimeout(updateAllPrices, 800);
  });

  document.addEventListener('cart:open', function () {
    setTimeout(updateAllPrices, 300);
  });

  document.addEventListener('drawer:open', function () {
    setTimeout(updateAllPrices, 300);
  });

})(); */






/* (function () {
  const config = window.CUSTOM_PRICING || {};
  const isLoggedIn = config.isLoggedIn || false;
  const promotions = config.promotions || [];

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' zł';
  }

  function getActivePromo() {
    const now = new Date();
    for (const promo of promotions) {
      if (promo.handle === 'member-base') continue;
      if (!promo.active) continue;
      const startsAt = promo.starts_at ? new Date(promo.starts_at) : null;
      const endsAt = promo.ends_at ? new Date(promo.ends_at) : null;
      const started = !startsAt || now >= startsAt;
      const notEnded = !endsAt || now <= endsAt;
      if (started && notEnded) return promo;
    }
    return null;
  }

  function calculatePrices(basePrice) {
    const promo = getActivePromo();
    const memberBase = promotions.find(p => p.handle === 'member-base');
    const memberBaseDiscount = memberBase ? memberBase.member_discount_percent : 10;

    let displayPrice, comparePrice;

    if (isLoggedIn) {
      if (promo && promo.member_discount_percent > 0) {
        comparePrice = basePrice;
        displayPrice = Math.round(basePrice * (1 - promo.member_discount_percent / 100));
      } else {
        comparePrice = basePrice;
        displayPrice = Math.round(basePrice * (1 - memberBaseDiscount / 100));
      }
    } else {
      if (promo && promo.discount_percent > 0) {
        comparePrice = basePrice;
        displayPrice = Math.round(basePrice * (1 - promo.discount_percent / 100));
      } else {
        comparePrice = 0;
        displayPrice = basePrice;
      }
    }

    return { displayPrice, comparePrice };
  }

  function updatePriceContainer(container) {
    const basePrice = parseInt(container.dataset.basePrice, 10);
    const priceMin = parseInt(container.dataset.priceMin, 10);
    const priceMax = parseInt(container.dataset.priceMax, 10);
    const hasVolumePricing = container.dataset.hasVolumePricing === 'true';

    if (!basePrice) return;

    const { displayPrice, comparePrice } = calculatePrices(basePrice);

    const priceLabel = container.querySelector('[data-price-label]');
    const compareLabel = container.querySelector('[data-compare-label]');
    const compareGroup = container.querySelector('.price-compare-group');

    if (hasVolumePricing && priceMin && priceMax) {
      const { displayPrice: minDisplay } = calculatePrices(priceMin);
      const { displayPrice: maxDisplay } = calculatePrices(priceMax);
      if (priceLabel) {
        priceLabel.textContent = formatMoney(minDisplay) + ' - ' + formatMoney(maxDisplay);
      }
    } else {
      if (priceLabel) {
        priceLabel.textContent = formatMoney(displayPrice);
      }
    }

    if (comparePrice > 0 && comparePrice > displayPrice) {
      if (compareLabel) compareLabel.textContent = formatMoney(comparePrice);
      if (compareGroup) {
        compareGroup.style.display = '';
      } else if (compareLabel) {
        const group = compareLabel.closest('[role="group"]');
        if (group) group.style.display = '';
      }
    } else {
      if (compareGroup) {
        compareGroup.style.display = 'none';
      } else if (compareLabel) {
        const group = compareLabel.closest('[role="group"]');
        if (group) group.style.display = 'none';
      }
    }
  }

  function updateCartPrices() {
    document.querySelectorAll('.cart-price-item[data-base-price]').forEach(function (container) {
      const basePrice = parseInt(container.dataset.basePrice, 10);
      const quantity = parseInt(container.dataset.lineQuantity, 10) || 1;
      if (!basePrice) return;

      const { displayPrice, comparePrice } = calculatePrices(basePrice);
      const lineTotal = displayPrice * quantity;
      const compareTotal = comparePrice * quantity;

      const priceLabel = container.querySelector('[data-price-label]');
      const compareLabel = container.querySelector('[data-compare-label]');
      const compareGroup = container.querySelector('.price-compare-group');

      if (priceLabel) {
        priceLabel.textContent = formatMoney(lineTotal);
      }

      if (comparePrice > 0 && comparePrice > displayPrice) {
        if (compareLabel) compareLabel.textContent = formatMoney(compareTotal);
        if (compareGroup) compareGroup.style.display = '';
      } else {
        if (compareGroup) compareGroup.style.display = 'none';
      }
    });
  }

function updateBadges() {
  const promo = getActivePromo();
  const memberBase = promotions.find(p => p.handle === 'member-base');

  document.querySelectorAll('.card-badge-promo').forEach(function (badge) {
    if (promo && promo.title) {
      badge.textContent = promo.title;
      badge.style.display = '';
    } else {
      badge.style.display = 'none';
    }
  });

  document.querySelectorAll('.card-badge-member').forEach(function (badge) {
    if (isLoggedIn && memberBase && memberBase.title) {
      badge.textContent = memberBase.title;
      badge.style.display = '';
    } else {
      badge.style.display = 'none';
    }
  });
}


  function updateAllPrices() {
    document.querySelectorAll('.price-container[data-base-price]').forEach(updatePriceContainer);
    updateCartPrices();
    updateBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllPrices);
  } else {
    updateAllPrices();
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('price-container')) {
            updatePriceContainer(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('.price-container[data-base-price]').forEach(updatePriceContainer);
            if (node.querySelectorAll('.cart-price-item[data-base-price]').length > 0) {
              updateCartPrices();
            }
            if (node.querySelectorAll('.card-badge-promo').length > 0) {
              updateBadges();
            }
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('input', function (e) {
    if (e.target.matches('input[type="search"], input[name="q"]')) {
      setTimeout(updateAllPrices, 500);
      setTimeout(updateAllPrices, 1000);
      setTimeout(updateAllPrices, 2000);
    }
  });

  document.addEventListener('focusin', function (e) {
    if (e.target.matches('input[type="search"], input[name="q"]')) {
      setTimeout(updateAllPrices, 300);
    }
  });

  document.addEventListener('click', function (e) {
    setTimeout(updateAllPrices, 300);
    setTimeout(updateAllPrices, 800);
  });

  document.addEventListener('cart:open', function () {
    setTimeout(updateAllPrices, 300);
  });

  document.addEventListener('drawer:open', function () {
    setTimeout(updateAllPrices, 300);
  });

})(); */









/* (function () {
  // Данные передаются из theme.liquid через window.CUSTOM_PRICING
  const config = window.CUSTOM_PRICING || {};
  const isLoggedIn = config.isLoggedIn || false;
  const promotions = config.promotions || [];
  const moneyFormat = config.moneyFormat || '{{amount}} zł';

  // Базовая скидка для авторизованных (10%)
  const AUTH_DISCOUNT = 0.10;

  // Форматирование цены в соответствии с форматом магазина
function formatMoney(cents, withCurrency) {
  const amount = (cents / 100).toFixed(2).replace('.', ',');
  return moneyFormat.replace('{{amount_with_comma_separator}}', amount)
                    .replace('{{amount}}', (cents / 100).toFixed(2));
}


  // Получаем суммарный процент всех активных акций
  function getActivePromoDiscount() {
    const now = new Date();
    let totalDiscount = 0;

    promotions.forEach(function (promo) {
      if (!promo.active) return;

      const startsAt = promo.starts_at ? new Date(promo.starts_at) : null;
      const endsAt = promo.ends_at ? new Date(promo.ends_at) : null;

      const started = !startsAt || now >= startsAt;
      const notEnded = !endsAt || now <= endsAt;

      if (started && notEnded) {
        totalDiscount += promo.discount_percent;
      }
    });

    return totalDiscount; // например 30
  }

  // Пересчёт цены с учётом скидок
  function calculatePrices(basePrice, promoPercent) {
    let displayPrice, comparePrice;

    if (isLoggedIn) {
      const authPrice = Math.round(basePrice * (1 - AUTH_DISCOUNT));
      if (promoPercent > 0) {
        comparePrice = authPrice;
        displayPrice = Math.round(authPrice * (1 - promoPercent / 100));
      } else {
        comparePrice = basePrice;
        displayPrice = authPrice;
      }
    } else {
      if (promoPercent > 0) {
        comparePrice = basePrice;
        displayPrice = Math.round(basePrice * (1 - promoPercent / 100));
      } else {
        comparePrice = 0;
        displayPrice = basePrice;
      }
    }

    return { displayPrice, comparePrice };
  }

  // Обновляем DOM для одного блока цены
  function updatePriceContainer(container) {
    const basePrice = parseInt(container.dataset.basePrice, 10);
    const priceMin = parseInt(container.dataset.priceMin, 10);
    const priceMax = parseInt(container.dataset.priceMax, 10);
    const hasVolumePricing = container.dataset.hasVolumePricing === 'true';
    const useCurrency = container.dataset.useCurrency === 'true';

    if (!basePrice) return;

    const promoPercent = getActivePromoDiscount();
    const { displayPrice, comparePrice } = calculatePrices(basePrice, promoPercent);

    const priceLabel = container.querySelector('[data-price-label]');
    const compareLabel = container.querySelector('[data-compare-label]');
    const compareGroup = container.querySelector('.price-compare-group');

    if (hasVolumePricing && priceMin && priceMax) {
      const { displayPrice: minDisplay } = calculatePrices(priceMin, promoPercent);
      const { displayPrice: maxDisplay } = calculatePrices(priceMax, promoPercent);
      if (priceLabel) {
        priceLabel.textContent = formatMoney(minDisplay, useCurrency) + ' - ' + formatMoney(maxDisplay, useCurrency);
      }
    } else {
      if (priceLabel) {
        priceLabel.textContent = formatMoney(displayPrice, useCurrency);
      }
    }

    if (comparePrice > 0 && comparePrice > displayPrice) {
      if (compareLabel) {
        compareLabel.textContent = formatMoney(comparePrice, useCurrency);
      }
      if (compareGroup) {
        compareGroup.style.display = '';
      } else if (compareLabel) {
        compareLabel.closest('[role="group"]').style.display = '';
      }
    } else {
      if (compareGroup) {
        compareGroup.style.display = 'none';
      } else if (compareLabel) {
        const group = compareLabel.closest('[role="group"]');
        if (group) group.style.display = 'none';
      }
    }
  }

  // Обновляем все блоки цен на странице
  function updateAllPrices() {
    document.querySelectorAll('.price-container[data-base-price]').forEach(updatePriceContainer);
  }

  // Запускаем после загрузки DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAllPrices);
  } else {
    updateAllPrices();
  }

  // Следим за динамически добавляемыми элементами (quick view, infinite scroll)
const observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      if (node.nodeType === 1) {
        if (node.classList && node.classList.contains('price-container')) {
          updatePriceContainer(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.price-container[data-base-price]').forEach(updatePriceContainer);
        }
      }
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });



})();



// Обработка поиска
document.addEventListener('input', function (e) {
  if (e.target.matches('input[type="search"], input[name="q"]')) {
    setTimeout(updateAllPrices, 500);
    setTimeout(updateAllPrices, 1000);
    setTimeout(updateAllPrices, 2000);
  }
});

// Также следим за кликом на поиск (для "Последно просмотренных")
document.addEventListener('focusin', function (e) {
  if (e.target.matches('input[type="search"], input[name="q"]')) {
    setTimeout(updateAllPrices, 300);
  }
}); */

/*   const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.classList && node.classList.contains('price-container')) {
            updatePriceContainer(node);
          }
          node.querySelectorAll && node.querySelectorAll('.price-container[data-base-price]').forEach(updatePriceContainer);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true }); */